export const ActionTypes = {
    UPDATE_WEEKLY_DURATION: "UPDATE_WEEKLY_DURATION_REQUEST",
    UPDATE_WEEKLY_DURATION_SUCCESS: "UPDATE_WEEKLY_DURATION_SUCCESS",
    UPDATE_WEEKLY_DURATION_FAILURE: "UPDATE_WEEKLY_DURATION_FAILURE",
}